import React from 'react';

import { FormattedMessage } from 'react-intl';

import { DropdownItem } from '@atlaskit/dropdown-menu-12';
import RecentIcon from '@atlaskit/icon/glyph/recent';
import Spinner from '@atlaskit/spinner';

import { useIntl } from 'src/hooks/intl';

import { useMergeData } from '../hooks/merge-data';

import messages from './merge-button.i18n';

const MergeDropdownItem = () => {
  const intl = useIntl();
  const { isMergePending, isAsyncMergeInProgress, onClick } = useMergeData();
  const loadingIcon = <Spinner size="small" />;

  return (
    <DropdownItem
      onClick={onClick}
      elemAfter={isAsyncMergeInProgress ? loadingIcon : null}
      elemBefore={
        isMergePending ? (
          <RecentIcon
            size="small"
            label={intl.formatMessage(messages.pendingMergeIconLabel)}
          />
        ) : undefined
      }
      isDisabled={isAsyncMergeInProgress}
    >
      <FormattedMessage {...messages.mergePullRequestAction} />
    </DropdownItem>
  );
};

export default React.memo(MergeDropdownItem);
